import type { Environment } from '@change-corgi/config/environments';

import __recaptcha from '../config/recaptcha.json';

export const recaptchaKey = __recaptcha.visible as Readonly<Record<Environment, string>>;
export const recaptchaInvisibleKey = __recaptcha.invisible as Readonly<Record<Environment, string>>;
